var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#FCC71D",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15C21.6716 15 21 15.6716 21 16.5V17.5C21 18.3284 21.6716 19 22.5 19H27.5C28.3284 19 29 18.3284 29 17.5V16.5C29 15.6716 28.3284 15 27.5 15H22.5Z",
    fill: "#FCC71D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 17.0366C18.2421 17.1072 17.448 17.3076 16.8787 17.8769C16 18.7556 16 20.1698 16 22.9983V28.9983C16 31.8267 16 33.2409 16.8787 34.1196C17.7574 34.9983 19.1716 34.9983 22 34.9983H28C30.8284 34.9983 32.2426 34.9983 33.1213 34.1196C34 33.2409 34 31.8267 34 28.9983V22.9983C34 20.1698 34 18.7556 33.1213 17.8769C32.552 17.3076 31.7579 17.1072 30.5 17.0366V17.5C30.5 19.1569 29.1569 20.5 27.5 20.5H22.5C20.8431 20.5 19.5 19.1569 19.5 17.5V17.0366ZM20 22.75C19.5858 22.75 19.25 23.0858 19.25 23.5C19.25 23.9142 19.5858 24.25 20 24.25H20.5C20.9142 24.25 21.25 23.9142 21.25 23.5C21.25 23.0858 20.9142 22.75 20.5 22.75H20ZM23.5 22.75C23.0858 22.75 22.75 23.0858 22.75 23.5C22.75 23.9142 23.0858 24.25 23.5 24.25H30C30.4142 24.25 30.75 23.9142 30.75 23.5C30.75 23.0858 30.4142 22.75 30 22.75H23.5ZM20 26.25C19.5858 26.25 19.25 26.5858 19.25 27C19.25 27.4142 19.5858 27.75 20 27.75H20.5C20.9142 27.75 21.25 27.4142 21.25 27C21.25 26.5858 20.9142 26.25 20.5 26.25H20ZM23.5 26.25C23.0858 26.25 22.75 26.5858 22.75 27C22.75 27.4142 23.0858 27.75 23.5 27.75H30C30.4142 27.75 30.75 27.4142 30.75 27C30.75 26.5858 30.4142 26.25 30 26.25H23.5ZM20 29.75C19.5858 29.75 19.25 30.0858 19.25 30.5C19.25 30.9142 19.5858 31.25 20 31.25H20.5C20.9142 31.25 21.25 30.9142 21.25 30.5C21.25 30.0858 20.9142 29.75 20.5 29.75H20ZM23.5 29.75C23.0858 29.75 22.75 30.0858 22.75 30.5C22.75 30.9142 23.0858 31.25 23.5 31.25H30C30.4142 31.25 30.75 30.9142 30.75 30.5C30.75 30.0858 30.4142 29.75 30 29.75H23.5Z",
    fill: "#FCC71D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInventory);
export default __webpack_public_path__ + "static/media/DashboardInventory.a55006eeeca0951142aa439c5c0b99df.svg";
export { ForwardRef as ReactComponent };